import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Clock, Facebook, Instagram } from 'lucide-react';
import { businessInfo } from '../data/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-wood-brown text-cream">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_lombardi-salumi/artifacts/roqe4rab_LOGO-ok-2022.png" 
              alt="Salumificio Lombardi" 
              className="h-12 w-auto mb-4"
            />
            <h3 className="font-serif text-xl font-bold mb-3">{businessInfo.name}</h3>
            <p className="text-cream/80 font-serif text-sm leading-relaxed">
              Dal {businessInfo.foundedYear}, tradizione e qualità nella lavorazione artigianale di salumi e carni fresche.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-lg font-bold mb-4 text-beige">Link Rapidi</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-cream/80 hover:text-cream transition-colors font-serif">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/prodotti" className="text-cream/80 hover:text-cream transition-colors font-serif">
                  I Nostri Prodotti
                </Link>
              </li>
              <li>
                <Link to="/barbecue" className="text-cream/80 hover:text-cream transition-colors font-serif">
                  Area Barbecue
                </Link>
              </li>
              <li>
                <Link to="/storia" className="text-cream/80 hover:text-cream transition-colors font-serif">
                  La Nostra Storia
                </Link>
              </li>
              <li>
                <Link to="/contatti" className="text-cream/80 hover:text-cream transition-colors font-serif">
                  Contatti
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-serif text-lg font-bold mb-4 text-beige">Contatti</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin size={18} className="text-beige mt-1 flex-shrink-0" />
                <span className="text-cream/80 text-sm font-serif">
                  {businessInfo.location.fullAddress}
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={18} className="text-beige flex-shrink-0" />
                <a href={`tel:${businessInfo.contact.phone}`} className="text-cream/80 hover:text-cream transition-colors text-sm font-serif">
                  {businessInfo.contact.phone}
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={18} className="text-beige flex-shrink-0" />
                <a href={`https://wa.me/${businessInfo.contact.whatsapp}`} className="text-cream/80 hover:text-cream transition-colors text-sm font-serif">
                  WhatsApp: {businessInfo.contact.whatsapp}
                </a>
              </li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div>
            <h4 className="font-serif text-lg font-bold mb-4 text-beige">Orari di Apertura</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-2">
                <Clock size={18} className="text-beige mt-1 flex-shrink-0" />
                <div className="text-sm font-serif">
                  <p className="text-cream/80 font-medium">Lunedì - Sabato</p>
                  <p className="text-cream/70">{businessInfo.hours.weekdays}</p>
                </div>
              </div>
              <div className="flex items-start space-x-2">
                <Clock size={18} className="text-beige mt-1 flex-shrink-0" />
                <div className="text-sm font-serif">
                  <p className="text-cream/80 font-medium">Domenica</p>
                  <p className="text-cream/70">{businessInfo.hours.weekend}</p>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className="mt-6">
              <h5 className="font-serif text-sm font-bold mb-3 text-beige">Seguici</h5>
              <div className="flex space-x-3">
                <a 
                  href={businessInfo.contact.facebook} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-cream/10 p-2 rounded-full hover:bg-cream/20 transition-colors"
                  aria-label="Facebook"
                >
                  <Facebook size={20} className="text-cream" />
                </a>
                <a 
                  href={businessInfo.contact.instagram} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-cream/10 p-2 rounded-full hover:bg-cream/20 transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram size={20} className="text-cream" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-cream/20 mt-10 pt-6">
          <div className="text-center text-cream/70 text-sm font-serif">
            <p>© {currentYear} {businessInfo.name}. Tutti i diritti riservati.</p>
            <p className="mt-1">Tradizione artigianale dal {businessInfo.foundedYear}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
